import React from 'react';
import { FlyoutProvider } from './shared/FlyoutContext';
import { useTranslation } from 'react-i18next';
import { BrowserRouter } from 'react-router-dom';
import { AppRouter } from './pages/AppRouter';
import { NotificationProvider } from './shared/notification/NotificationContext';
import { AppContainer } from './pages/AppContainer';

function App() {
  const { t } = useTranslation('odm');

  return (
    <FlyoutProvider>
      <NotificationProvider
        defaultModalHeading={t('globalNotifications.modalHeading')}
        defaultModalConfirmationButtonLabel={t(
          'globalNotifications.modalConfirm'
        )}
        defaultModalAbortButtonLabel={t('globalNotifications.modalAboard')}
        defaultModalContent={t('globalNotifications.modalHint')}
        defaultAlertErrorMessage={t('globalNotifications.alertError')}
        defaultAlertSuccessMessage={t('globalNotifications.alertSuccess')}
      >
        <AppContainer>
          <BrowserRouter>
            <AppRouter />
          </BrowserRouter>
        </AppContainer>
      </NotificationProvider>
    </FlyoutProvider>
  );
}

export default App;
